import React from 'react'
import { Layout } from 'antd'
import './index.style.scss'
import SubmitIssuedCheckForm from './components/SubmitIssuedCheckForm'
import ProcessingResults from './components/ProcessingResults'

const SubmitIssuedCheckContent: React.FC = () => {
  return (
    <Layout.Content className='submit-issued-check-container' style={{ padding: 24 }}>
      <SubmitIssuedCheckForm />
      <ProcessingResults />
    </Layout.Content>
  )
}

export default SubmitIssuedCheckContent
